<template>
  <vx-card title="Past Invoices History">
    <vs-table max-items="3" pagination :data="pastInvoices">
      <template slot="thead">
        <vs-th>Date</vs-th>
        <vs-th>Description</vs-th>
        <vs-th>Amount</vs-th>
        <vs-th>Invoice Link</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(invoice, index) in data">
          <vs-td>
            {{ data[index].date }}
          </vs-td>
          <vs-td>
            {{ data[index].description }}
          </vs-td>
          <vs-td> {{ data[index].currency + data[index].amount }} </vs-td>
          <vs-td>
            <vs-button type="flat" color="dark" @click="downloadInvoice(data[index].invoiceLink)">
              <feather-icon icon="DownloadCloudIcon" svgClasses="h-5 w-5" />
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import { epochToDate, getStripeForCloudifyUrl } from '@/utils/misc'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
export default {
  data() {
    return {
      pastInvoices: [],
      stripeCustomerId: null,
    }
  },
  methods: {
    /**
     * This function is used to fetch the users invoices from the stripe.
     */
    async fetchPastInvoices() {
      const userId = this.$store.state.admin.access ? this.$store.state.DB.owner : firebase.auth().currentUser.uid
      const cust = await firebase.firestore().collection('customers').doc(userId).get()
      if (!cust.exists) {
        console.log('No stripe customer found in firestore')
      } else {
        this.stripeCustomerId = cust.data().stripeId
      }
      const { data: res } = await axios.get(`${getStripeForCloudifyUrl()}/stripeGetInvoices?customerId=${this.stripeCustomerId}`)
      for (const invoice of res.data) {
        if (invoice.paid) {
          this.pastInvoices.push({
            date: epochToDate(invoice.status_transitions.finalized_at, true),
            description: invoice.id,
            currency: this.getCurrencySymbol(invoice.currency),
            amount: invoice.amount_due / 100,
            invoiceLink: invoice.invoice_pdf,
          })
        }
      }
    },
    /**
     * This function is used to get the currency symbol for the provided currency
     */
    getCurrencySymbol(currency) {
      const currencySymbolLookup = {
        dkk: 'Kr.',
        usd: '$',
        eur: '€',
      }
      return currencySymbolLookup[currency]
    },

    /**
     * This function is used to download the invoices of the user
     * @param {String} invoiceLink this  is a url that is responsible for downloading the invoice of the user.
     */
    downloadInvoice(invoiceLink) {
      try {
        window.open(invoiceLink)
        this.$rollbar.info(`${this.stripeCustomerId} Downloaded The Invoice`)
      } catch (error) {
        this.$rollbar.error(`${this.stripeCustomerId} Downloading The Invoice is Failed`, { error })
      }
    },
  },
  async mounted() {
    this.fetchPastInvoices()
  },
}
</script>
